import { Box, Typography } from '@mui/material';
import { tss } from 'tss-react/mui';
import { Option } from 'types/global';

interface RecentlyLaunchedFilterProps {
  updateFilter: (value: Option[]) => void;
  years: {
    year: string;
    active: boolean;
  }[];
}
//To add a new year just add it to RECENTLY_LAUNCHED_FILTERS in Contansts.ts
const RecentlyLaunchedFilter = ({
  updateFilter,
  years
}: RecentlyLaunchedFilterProps) => {
  const handleYearsUpdate = (years: { year: string; active: boolean }[]) => {
    updateFilter(
      years.some(year => year.active)
        ? [
            {
              value: [...years.filter(year => year.active).map(el => el.year)],
              label: ''
            }
          ]
        : []
    );
  };
  const { classes, cx } = useStyles();
  return (
    <Box
      key={'recently-launched'}
      sx={{
        padding: '12px 16px'
      }}
    >
      <Typography
        style={{
          color: '#343434',
          fontSize: '14px',
          fontWeight: 300,
          letterSpacing: '.13px',
          textTransform: 'uppercase'
        }}
      >
        Recently Launched
      </Typography>
      <div className={classes.root}>
        {years &&
          years.map((year: { year: string; active: boolean }) => (
            <div
              key={year.year}
              className={cx(
                classes.filter,
                year.active && classes.filterClicked
              )}
              onClick={() => {
                const newYears = [
                  ...years.map(yearState => {
                    if (yearState.year === year.year)
                      return {
                        year: yearState.year,
                        active: !yearState.active
                      };
                    else return yearState;
                  })
                ];
                handleYearsUpdate(newYears);
              }}
            >
              {year.year}
            </div>
          ))}
      </div>
    </Box>
  );
};

const useStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px',
    gap: '9px'
  },
  filter: {
    '&:hover': { cursor: 'pointer' },
    borderRadius: 4,
    marginTop: '8px',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: 'Roboto',
    color: '#c2c2c2',
    padding: '4px 6px',
    border: '1px solid var(--falcon-border-color)',
    backgroundColor: 'white',
    userSelect: 'none',
    '&:active': {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main
    }
  },
  filterClicked: {
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main
  }
}));

export default RecentlyLaunchedFilter;
